import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=acdcc3aa&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=acdcc3aa&prod&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=acdcc3aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdcc3aa",
  null
  
)

export default component.exports